import BizFilePackageImage from "./assets/images/packages/biz-file.png";
import BizPrintPackageImage from "./assets/images/packages/biz-print.png";
import ClientsPlatformPackageImage from "./assets/images/packages/clients-platform.png";
import CustomerRelationsManagementPackageImage from "./assets/images/packages/customer-relations-management.png";
import DashboardsPackageImage from "./assets/images/packages/dashboards.png";
import InventoryPackageImage from "./assets/images/packages/inventory.png";
import LookupPackageImage from "./assets/images/packages/lookup.png";
import NonConformanceReportsPackageImage from "./assets/images/packages/non-conformance-reports.png";
import NotificationsPackageImage from "./assets/images/packages/notifications.png";
import PurchasingPackageImage from "./assets/images/packages/purchasing.png";
import ProductionPackageImage from "./assets/images/packages/production.png";
import SalesPackageImage from "./assets/images/packages/sales.png";
import TaskAndNoteManagementPackageImage from "./assets/images/packages/task-and-note-management.png";
import TimeTrackerPackageImage from "./assets/images/packages/time-tracker.png";
import WarrantyAndReturnPackageImage from "./assets/images/packages/warranty-and-return.png";
import InventoryGeneralSearchFeatureImage from "./assets/images/features/inventory_general-search.png";
import InventorySalesFeatureImage from "./assets/images/features/inventory_sales.png";
import InventoryPurchaseFeatureImage from './assets/images/features/inventory_purchase.png';
import InventoryCountingFeatureImage from './assets/images/features/inventory_counting.png';
import InventoryWarehouseManagementFeatureImage from './assets/images/features/inventory_warehouse-management.png';
import InventoryProductInformationFeatureImage from './assets/images/features/inventory_product-information.png';
import InventoryInventoryAdjustmentFeatureImage from './assets/images/features/inventory_inventory-adjustment.png';
import InventoryInventoryTransferFeatureImage from './assets/images/features/inventory_inventory-transfer.png';
import InventoryProductAvailabilityFeatureImage from './assets/images/features/inventory_product-availability.png';
import LookupSearchEnginesFeatureImage from './assets/images/features/lookup_multiple-search-engines.png';
import LookupProductInformationFeatureImage from './assets/images/features/lookup_product-information.png';
import LookupAnalyticsFeatureImage from './assets/images/features/lookup_analytics-and-search-history.png';
import LookupComparisonFeatureImage from './assets/images/features/lookup_comparison-lists.png';
import WarrantyAndReturnRequestsFeatureImage from './assets/images/features/warranty_requests.png';
import WarrantyAndReturnDriversChecklistsFeatureImage from './assets/images/features/warranty_drivers-checklist.png';
import WarrantyAndReturnLiveChatFeatureImage from './assets/images/features/warranty_live-chat.png';
import SalesQuotesAndSalesOrdersFeatureImage from './assets/images/features/sales_quotes-and-sales-orders.png';
import SalesInvoicesAndCreditsFeatureImage from './assets/images/features/sales_invoices-and-credits.png';
import SalesPriceLevelsAndProductPricingFeatureImage from './assets/images/features/sales_price-levels.png';
import SalesAccountingAndAccountReceivablesFeatureImage from './assets/images/features/sales_accounting.png';
import SalesOnlinePaymentsFeatureImage from './assets/images/features/sales_online-payments.png';
import SalesFreightAndFreightFeesFeatureImage from './assets/images/features/sales_freight-and-freight-fees.png';
import SalesGiftCardsAndCouponsFeatureImage from './assets/images/features/sales_gift-cards-and-coupons.png';
import SalesPriceMatricesAndBulkPriceManipulationFeatureImage from './assets/images/features/sales_price-matrices.png';
import BizPrintCatalogFeatureImage from './assets/images/features/biz-print_catalog.png';
import BizPrintLabelingFeatureImage from './assets/images/features/biz-print_labeling.png';
import BizFileFileAndFolderManagementFeatureImage from './assets/images/features/biz-file_file-management.png';
import BizFileSharingWithOthersFeatureImage from './assets/images/features/biz-file_sharing-with-others.png';
import BizFileAccessibleAnywhereFeatureImage from './assets/images/features/biz-file_accessible-anytime.png';
import PurchasingPurchaseGeneratorsFeatureImage from './assets/images/features/purchasing_purchase-generators.png';
import PurchasingPurchaseHistoryAndInformationFeatureImage from './assets/images/features/purchasing_purchase-information.png';
import TimeTrackerTimeKeepingFeatureImage from './assets/images/features/time-tracker_time-tracking.png';
import TimeTrackerReportsFeatureImage from './assets/images/features/time-tracker_reports.png';
import DashboardsSystemWideDashboardsFeatureImage from './assets/images/features/dashboards_system-wide-dashboards.png';
import DashboardsSectionSpecificDashboardsFeatureImage from './assets/images/features/dashboards_section-specific-dashboards.png';
import DashboardsInteractivity from './assets/images/features/dashboard-interactivity.jpg';
import NotificationsOperatorNotificationsFeatureImage from './assets/images/features/notifications_operator-notifications.png';
import NotificationsCustomerNotificationsFeatureImage from './assets/images/features/notifications_customer-notifications.png';
import NonConformanceReportsConfigurableProcessSettingsFeatureImage from './assets/images/features/ncr_configurable-settings.png';
import BizPrintPackingListsFeatureImage from './assets/images/features/biz-print_packing-lists.png';
import ClientsPlatformDynamicHomepagesFeatureImage from './assets/images/features/client-platform_dynamic-homepages.png';
import ClientsPlatformLookupAndProductInformationFeatureImage
    from './assets/images/features/client-platform_lookup-and-product-information.png';
import ClientsPlatformPricingAndSalesFeatureImage from './assets/images/features/client-platform_pricing-and-sales.png';
import ClientsPlatformContentManagementSystemFeatureImage from './assets/images/features/client-platform_content-management-system.png';
import TaskAndNoteManagementTaskManagementFeatureImage from './assets/images/features/tasks-and-notes_task-management.png';
import TaskAndNoteManagementNoteManagementFeatureImage from './assets/images/features/tasks-and-notes_note-management.png';
import CustomerRelationsManagementLeadsManagementFeatureImage from './assets/images/features/crm_lead-management.png';
import CustomerRelationsManagementVisitsFollowUpsAndOffersFeatureImage from './assets/images/features/crm_lead-management.png';
import CustomerRelationsManagementAccountAndMemberManagementFeatureImage from './assets/images/features/crm_account-management.png';
import CustomerRelationsManagementTasksAndNotesFeatureImage from './assets/images/features/crm_tasks-and-notes.png';
import CustomerRelationsManagementLogsAndHistoryFeatureImage from './assets/images/features/crm_logs-and-history.png';
import NonConformanceReportsNCRSubmissionAndInformationFeatureImage from './assets/images/features/ncr_submission-and-information.png';
import NonConformanceReportsTasksAndNotesFeatureImage from './assets/images/features/ncr_tasks-and-notes.png';


export interface Package {
    title: string;
    slug: string;
    description: string;
    color: string;
    planned: boolean;
    specialOffer: boolean;
    image: string;
    content: string;
    keyBenefits: PackageKeyBenefit[];
    features: PackageFeature[];
    tutorialLinks: PackageTutorial[];
    tutorialsPlaylistLink: string | null;
    documentationLink: string | null;
}

export interface PackageTutorial {
    title: string;
    link: string;
}

export interface PackageKeyBenefit {
    text: string;
    points: string[];
}

export interface PackageFeature {
    title: string;
    description: string;
    addOn: boolean;
    planned?: boolean;
    points: string[];
    image: string;
}


export interface IStaticContent {
    packages: Package[];

}

const StaticContent: IStaticContent = {

    "packages": [
        {
            "title": "Bizkey B.I.",
            "slug": "bizkey-business-intelligence",
            "description": "Our business intelligence package is designed to provide you with a fast, efficient and highly customizable analytical toolset and enables you and your business to gain" +
                " the necessary insight to take your business tot he next level.",
            "color": "rgba(253, 130, 156, 0.5)",
            "image": DashboardsPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "Our business intelligence package is designed to provide you with a fast, efficient and highly customizable analytical toolset and enables you and your business to gain the" +
                " necessary insight to take your business tot he next level.",
            "keyBenefits": [
                {
                    text: "Fully Customizable Widgets and Dashboards",
                    points: ["Equip your team with dynamic and adaptable visualization tools that facilitate" +
                    " in-depth analysis of business operations and outcomes. Tailor these tools to meet specific analytical needs and business expectations. You are in charge of what you see and" +
                    " how you see it"],
                },
                {
                    text: "User-Centric Design",
                    points: ["Designed with the user in mind, our system makes it easy to create and modify visualizations. Users can adjust the appearance, underlying data, or placement on the" +
                    " dashboard, ensuring that the tools fit perfectly with their workflow."],
                },
                {
                    text: "Personalized Dashboards",
                    points: ["Allows each operator to create and manage their own dashboards independently, and even customize the. This feature ensures that" +
                    " modifications do not interfere with other users’ views or access to reporting tools, enhancing personal productivity without disrupting the team’s workflow."],
                },
            ],
            "features": [
                {
                    "title": "Unlimited Widgets in various visualization Shapes",
                    "addOn": false,
                    "description": "Each dashboard can house an unlimited number of highly customizable widgets, allowing users to tailor their analytical environment to their specific needs." +
                        " These widgets can be arranged and modified freely, providing a personalized experience that enhances data interpretation and decision-making.",
                    image: DashboardsSystemWideDashboardsFeatureImage,
                    points: [
                        "Diverse Visualization Options: Choose from seven different types of visualizations to best represent your data, ensuring clarity and effectiveness in analysis. Shapes from" +
                        " tabular data, bar charts, line charts, statistical data points, tree-maps,  and many more advanced visualization types",
                        "Customizable Data Sources: Select and configure the underlying data for each widget, allowing for tailored insights that align with specific business questions or objectives.",
                        "Flexible Layouts: Arrange widgets on the dashboard according to personal preferences, enabling a workflow that suits individual analytical styles and enhances productivity.",
                    ],
                },
                {
                    "title": "Performant and Cost effective",
                    "addOn": false,
                    "description": "Our BI package is engineered for high performance and cost efficiency. With usage of our Just in time technology, we ensure only the data associated with the" +
                        " currently visible portions of your dashboard widgets are queried and processed. This approach minimizes resource consumption and maximizes speed, providing a seamless user experience even with large datasets.",
                    image: DashboardsSectionSpecificDashboardsFeatureImage,
                    points: [
                        "Optimized Data Handling: By querying only the data necessary for the visible sections of your dashboard, we reduce load times and enhance responsiveness.",
                        "Scalable Performance: Our system is designed to handle varying data sizes and complexities without compromising on speed or efficiency, ensuring consistent performance as your business grows.",
                    ],
                },
                {
                    title: "A Conversion with your Data",
                    "addOn": false,
                    "description": "",
                    image: DashboardsInteractivity,
                    points: [
                        "Dashboard Level Filtering and Widget level filters allows you to view the same underlying data through different lenses, giving you the ability to analyze trends and patterns from multiple perspectives.",
                        "Fully Interactive: clicking on different lines or bars or even tabular rows will trigger a propagated change through your dashboard" +
                        " to provide granular insight into your data. This interactivity allows users to explore data relationships and trends dynamically, enhancing their understanding and" +
                        " enabling more informed decision-making.",
                        "Our Bizkey B.I. package changes the dynamic of analytics from a static view created by an analyst to a dynamic conversation with your data.",
                    ],
                },
                // {
                //     "title": "System Wide Dashboards",
                //     "addOn": false,
                //     "description": "These dashboards provide a holistic view of all existing data within the system, designed primarily for administrative analysis. While the underlying data of these dashboards is not highly configurable—to maintain the integrity of predefined visualizations—they offer crucial insights into the overall operations of the organization.",
                //     image: DashboardsSystemWideDashboardsFeatureImage,
                //     "points": [
                //         "Predefined Dashboards: Specifically crafted for administrative needs, these dashboards allow for a" +
                //         " comprehensive overview of the system's performance.",
                //         "Insightful Overview: Utilize easy-to-understand tools that facilitate comparison and analysis, helping administrators to effectively" +
                //         " oversee and optimize operations.",
                //         "Strategic Impact: These dashboards are invaluable for organizations aiming to increase revenue and realize their operational" +
                //         " potential.",
                //     ]
                // },
                // {
                //     "title": "Section Specific Dashboards",
                //     "addOn": false,
                //     "description": "Tailored for individual operational needs, these dashboards allow operators to generate and customize visualizations based on specific data sections. Each operator can create a personalized dashboard that reflects their unique requirements.",
                //     image: DashboardsSectionSpecificDashboardsFeatureImage,
                //     "points": [
                //         "Flexible Visualization Options: Operators can select from seven different visualization types to best suit" +
                //         " their analysis needs.",
                //         "Dynamic Data Integration: Customize the underlying data axes for charts and visualizations, choosing directly from data relevant to" +
                //         " the specific section.",
                //         "Customizable Filters: Apply dynamically created filters to each chart, enhancing the specificity and relevance of the results.",
                //
                //     ]
                // },
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Purchasing",
            "slug": "purchasing",
            "description": "The Purchasing module offers intelligent suggestions and streamlined vendor comparison, seamlessly integrated with Spire for efficient procurement operations.",
            "color": "rgba(125,181,255,0.5)",
            "image": PurchasingPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "The Purchasing module offers intelligent suggestions and streamlined vendor comparison, seamlessly integrated with Spire for efficient procurement operations.",
            "keyBenefits": [
                {
                    text: "Intelligent Suggestive System",
                    points: ["Our system enhances ordering efficiency with a sophisticated suggestive feature that" +
                    " recommends the optimal quantity of each product to order. This recommendation is based on a comprehensive analysis of multi-variant parameters, ensuring that your stock levels are precisely aligned with demand.",]
                },
                {
                    text: "Purchase Planning",
                    points: ["Streamline the often tedious process of selecting vendors with our planning feature, which simplifies" +
                    " the comparison and selection process. This tool helps you identify the best vendors based on criteria such as price, quality, warranty rates, sales history and many more" +
                    " crucial pieces of information, making it easier to make informed purchasing decisions.",]
                },
                {
                    text: "Seamless Integration with Spire System",
                    points: ["Fully integrated with the Spire system, our tool enhances its functionality and" +
                    " synchronizes seamlessly with your existing workflows, adding robustness and reliability to your operations.",]
                },
            ],
            "features": [
                {
                    "title": "Purchase Planning",
                    "addOn": false,
                    "description": "Enhance your procurement process with our Purchase planning feature, which simplifies and optimizes the selection and purchasing decisions from vendors. This" +
                        " tool provides a detailed overview of vendors offering the required products and helps you make informed choices based on comprehensive vendor information.",
                    image: PurchasingPurchaseGeneratorsFeatureImage,
                    "points": [
                        "Simultaneous Product Management: Handle multiple product requirements in one go, enhancing efficiency.",
                        "Comprehensive Vendor Insights: Access detailed information about each vendor, including pricing, warranty rates, sales history, and more, to make well-informed purchasing decisions.",
                        "Comprehensive Sales Integration: Fully integrated with Spire’s sales and inventory management systems, ensuring a cohesive and streamlined experience."
                    ]
                },
                {
                    "title": "Purchase History and Information",
                    "addOn": false,
                    "planned": true,
                    "description": "Maintain full oversight of your purchase orders with our comprehensive management system. Access detailed information about each order, including vendor details, shipment tracking, and product lists, to effectively anticipate and manage deliveries.",
                    image: PurchasingPurchaseHistoryAndInformationFeatureImage,
                    "points": [
                        "Detailed Order Insights: View complete details of each purchase order, including their current status and full" +
                        " vendor and shipping information.",
                        "Efficient Management Tools: Navigate and manage past purchase orders easily, with an intuitive interface designed to simplify your" +
                        " procurement workflow.",
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Production",
            "slug": "production",
            "description": "The Production module offers seamless integration with Spire, providing intelligent production planning and real-time tracking to optimize manufacturing processes and enhance operational efficiency.",
            "color": "rgba(125,255,251,0.5)",
            "image": ProductionPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "The Production module offers seamless integration with Spire, providing intelligent production planning and real-time tracking to optimize manufacturing processes and enhance operational efficiency.",
            "keyBenefits": [
                {
                    text: "User centric design",
                    points: ["Streamline the often tedious process of production planning with our planning feature, which simplifies" +
                    " the fetching and putting together the Bill of Material for complex orders. This tool helps you get a quick overview of how many products can be created with current stock" +
                    " levels, and how many more materials are needed, following a priority stack queue",]
                },
                {
                    text: "Seamless Integration with Spire System",
                    points: ["Fully integrated with the Spire system, our tool enhances its functionality and" +
                    " synchronizes seamlessly with your existing workflows, adding robustness and reliability to your operations.",]
                },
            ],
            "features": [
                {
                    "title": "Production Planning",
                    "addOn": false,
                    "description": "Enhance your production process with our Production planning feature, which simplifies and optimizes the planning and manufacturing decisions. This" +
                        " tool provides a detailed overview of current stock levels and helps you make informed choices based on comprehensive material requirements.",
                    image: PurchasingPurchaseGeneratorsFeatureImage,
                    "points": [
                        "Comprehensive Material Insights: Access detailed information about each material, including current stock levels, required quantities, and more, to make well-informed production decisions.",
                        "Automatically Saved Plans: All production plans are automatically saved in the system for future reference and tracking.",
                        "Seamless Spire Integration: Fully integrated with Spire’s inventory and production management systems, ensuring a cohesive and streamlined experience."
                    ]
                },
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "BizInventory",
            "slug": "inventory",
            "description": "Our Inventory Solution offers a streamlined, cloud-based platform with a mobile app and web interface for efficient inventory management across multiple warehouses, integrating seamlessly with Spire to enhance operational efficiency without additional hardware.",
            "color": "rgba(155, 198, 198, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": InventoryPackageImage,
            "content": "Our Inventory Solution provides a streamlined, cloud-based platform that includes both a mobile app and web interface, enabling efficient inventory management across multiple warehouses. It integrates seamlessly with Spire systems, boosting operational efficiency without the need for additional hardware.",
            "keyBenefits": [
                {
                    "text": "Dual Platform Accessibility",
                    "points": [
                        "A mobile application available on both Android and iOS, designed for inventory personnel to manage daily operations",
                        "A web-based software tailored for system administrators, ideal for reporting and administrative tasks."
                    ]
                },
                {
                    "text": "Hardware-Free",
                    "points": [
                        "Begin using the system immediately without the need for additional hardware, including seamless scanning capabilities."
                    ]
                }
            ],
            "features": [
                {
                    "title": "General Search",
                    "description": "Utilize our search engine to effortlessly access any record within the system by simply entering its unique code. This feature supports a broad range of queries, including sales orders, purchase orders, warehouse aisle sections, and product details.",
                    "addOn": false,
                    image: InventoryGeneralSearchFeatureImage,
                    "points": [
                        "Quickly input your code to navigate directly to the desired record.",
                        "Experience rapid search results, typically returned in less than a second.",
                        "Comprehensive search capabilities across products, serial numbers, sales and purchase orders, as well as specific locations within the warehouse like aisles, sections, and rows."
                    ]
                },
                {
                    "title": "Sales",
                    "description": "Access and manage your sales orders efficiently with our system. You can view all existing orders and filter them by submission date or order number. Effortlessly adjust orders by adding or removing serial numbers, or update counts of unserialized products simply by scanning their barcodes.",
                    "addOn": false,
                    image: InventorySalesFeatureImage,
                    "points": [
                        "Seamlessly integrated with Spire’s sales and inventory management systems.",
                        "Automatically adjusts stock levels by reserving committed products.",
                        "Employs a \"first in, first out\" algorithm to optimize product allocation to sales orders."
                    ]
                },
                {
                    "title": "Purchase",
                    "description": "Efficiently manage your procurement process by viewing and interacting with a list of all existing purchase orders. For each order, you can see detailed lists of included products and seamlessly commit these items into the system.",
                    "addOn": false,
                    image: InventoryPurchaseFeatureImage,
                    "points": [
                        "Fully integrated with Spire’s purchase and inventory management systems, ensuring a cohesive and streamlined experience"
                    ]
                },
                {
                    "title": "Counting",
                    "description": "Streamline the process of inventory management with our comprehensive counting tools. Start a counting session to temporarily freeze current stock levels, allowing for accurate and undisturbed counting, whether for your entire inventory or specific sections.",
                    "addOn": false,
                    image: InventoryCountingFeatureImage,
                    "points": [
                        "Receive a variety of detailed reports post-count, including \"General Report,\" \"Frozen Items,\" and \"Scanned Items\", available in multiple formats.",
                        "Fully integrated with Spire's counting system to ensure seamless operation and data integrity."
                    ]
                },
                {
                    "title": "Warehouse Management",
                    "description": "Customize your inventory structure within our system by setting up Aisles, Sections, and Rows, with each being a defined sub-section of the other. This flexible structure allows you to efficiently manage and move items within your inventory spaces.",
                    "addOn": false,
                    image: InventoryWarehouseManagementFeatureImage,
                    "points": [
                        "Effortlessly create, modify, and visualize your aisles, sections, and rows.",
                        "Accurately monitor and manage stock levels in each specific area, enhancing operational efficiency and inventory control."
                    ]
                },
                {
                    "title": "Product Information",
                    "description": "Access comprehensive details of each product, including images, size, weight, and serial numbers. Track the real-time location and history of each item to maintain accurate and up-to-date inventory records.",
                    "addOn": false,
                    image: InventoryProductInformationFeatureImage,
                    "points": [
                        "Manage product information with ease, view real-time stock levels, and track the locations of individual items.",
                        "Understand the movement and history of each serial number within your inventory system."
                    ]
                },
                {
                    "title": "Inventory Adjustment",
                    "description": "Optimize your stock levels with our user-friendly interface designed for making quick and precise inventory adjustments. Whether adjusting a single product or a batch, our system simplifies the process.",
                    "addOn": false,
                    image: InventoryInventoryAdjustmentFeatureImage,
                    "points": [
                        "Access detailed visualization reports and a complete history of inventory adjustments to maintain accuracy and accountability.",
                        "Make multi-product adjustments in a single request, enhancing efficiency and reducing errors."
                    ]
                },
                {
                    "title": "Inventory Transfer",
                    "description": "Simplify the movement of products within your inventory through dedicated transfer channels, designed to minimize human error and streamline operations.",
                    "addOn": false,
                    image: InventoryInventoryTransferFeatureImage,
                    "points": [
                        "Use our integrated mobile app and web platform for a comprehensive administrative overview.",
                        "Automatically update stock levels and location counts, reducing manual errors and improving accuracy.",
                        "Quickly identify and correct any incorrectly transferred items, ensuring inventory integrity."
                    ]
                },
                {
                    "title": "Product Availability",
                    "description": "Monitor the real-time availability of products across all locations, including a detailed view of stock status such as \"On Purchase,\" \"Committed,\" and \"Back Ordered.\"",
                    "addOn": false,
                    image: InventoryProductAvailabilityFeatureImage,
                    "points": [
                        "Access a complete overview of product availability across partner inventories, facilitating better collaboration and supply chain management."
                    ]
                }
            ],
            "tutorialsPlaylistLink": "https://youtube.com/playlist?list=PLyo5_erAkDbSA4iQeIA9fG2jSmDd8O7-F&si=rEMVPGeBLMp_VVQ5",
            "tutorialLinks": [
                {
                    title: "Overview & setup tutorial",
                    link: "https://www.youtube.com/embed/fA3vCapC2j4?si=y2nM_zu1opysZa6p",
                },
                {
                    title: "Purchasing tutorial",
                    link: "https://www.youtube.com/embed/fiPvU_14Hiw?si=kX6AxIoeIUCecWWA",
                },
                {
                    title: "Counting tutorial",
                    link: "https://www.youtube.com/embed/RCIR1JdH2Hc?si=if-4MrSWAb1xaoDh",
                },
                {
                    title: "Inventory management tutorial",
                    link: "https://www.youtube.com/embed/RGlMuvP3Wno?si=nxs7Vy8SUjallwM-",
                },
                {
                    title: "Move parts tutorial",
                    link: "https://www.youtube.com/embed/Xok3U18D2cM?si=9GDdoWSnwel2zXAR",
                },
            ],
            "documentationLink": null,
        },
        {
            "title": "Lookup",
            "slug": "lookup",
            "description": "Our Lookup Solution, available on both mobile and web platforms, streamlines product discovery with advanced search technologies, providing detailed product insights, analytical tools for business guidance, and comparison features for efficient selection.",
            "color": "rgba(184, 184, 255, 0.6)",
            "planned": false,
            "specialOffer": true,
            "image": LookupPackageImage,
            "content": "Our Lookup Solution, available on both mobile and web platforms, streamlines product discovery with advanced search technologies, providing detailed product insights, analytical tools for business guidance, and comparison features for efficient selection.",
            "keyBenefits": [
                {
                    "text": "Dual Platform Accessibility",
                    "points": [
                        "A versatile mobile application, available on both Android and iOS, designed for system operators and administrators to manage operations on the go.",
                        "A robust web-based software specifically developed for system administrators to perform administrative duties efficiently."
                    ]
                },
                {
                    "text": "Advanced Search Capabilities",
                    "points": [
                        "Utilize multiple innovative search methods to quickly locate products within your catalog, leveraging the latest technology for maximum efficiency."
                    ]
                },
                {
                    "text": "Analytical Insights",
                    "points": [
                        "Access powerful analytical tools that provide strategic insights, helping guide your business towards greater success and informed decision-making."
                    ]
                }
            ],
            "features": [
                {
                    "title": "Multiple Search Engines",
                    "description": "Optimize your product search with our diverse range of search engines, each tailored to different needs and information types",
                    "addOn": false,
                    image: LookupSearchEnginesFeatureImage,
                    "points": [
                        "Basic Search Engine: Ideal for quick searches, this engine uses a combination of keywords, part numbers, part codes, and tags.",
                        "Application Search Engine: Search products by make, model, and year, perfect for identifying specific applications.",
                        "Technical Search Engine: Focuses on detailed categorical technical properties for precision searching.",
                        "Magic Search Engine: Simplify your search with a keyword-driven approach, retrieving products with minimal input."
                    ]
                },
                {
                    "title": "Product Information",
                    "description": "Gain comprehensive insights into each product",
                    "addOn": false,
                    image: LookupProductInformationFeatureImage,
                    "points": [
                        "Access detailed product information, including category, technical specifications, applications, notes, technical files, feedback, and images.",
                        "Check real-time availability across partner inventories if the Inventory package is included.",
                        "Manage pricing information and report lost sales with the Sales package.",
                        "Create and manage shareable links of product details with the Website package."
                    ]
                },
                {
                    "title": "Analytics and Search History",
                    "description": "Leverage data to enhance decision-making",
                    "addOn": false,
                    image: LookupAnalyticsFeatureImage,
                    "points": [
                        "Analyze search engine usage, including keywords and product interactions, to identify trends and optimize offerings.",
                        "Utilize visualization tools to examine search histories and keyword details for better strategic planning.",
                        "Maintain a recorded history of customer searches, including all search parameters and product interactions."
                    ]
                },
                {
                    "title": "Comparison Lists",
                    "description": "Make informed decisions with our comparison tools",
                    "addOn": false,
                    image: LookupComparisonFeatureImage,
                    "points": [
                        "Compare products based on their technical properties, images, and notes in a structured format.",
                        "View products side by side to easily discern the best fit for specific needs.",
                        "Support for comparing multiple products simultaneously, enhancing user experience and decision-making processes."
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Warranty & Return",
            "slug": "warranty-return",
            "description": "Our Warranty and Return solution, accessible via both mobile and web platforms, revolutionizes product warranty and return processes with extensive management features, live chat for instant communication with customers and vendors, and dynamic checklist capabilities for thorough request tracking.",
            "color": "rgba(252, 174, 73, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": WarrantyAndReturnPackageImage,
            "content": "Our Warranty and Return solution, accessible via both mobile and web platforms, revolutionizes product warranty and return processes with extensive management features, live chat for instant communication with customers and vendors, and dynamic checklist capabilities for thorough request tracking.",
            "keyBenefits": [
                {
                    "text": "Dual Platform Accessibility",
                    "points": [
                        "Our mobile application, available on both Android and iOS, is tailored for operators and administrators, providing on-the-go access to system management.",
                        "A comprehensive web-based software designed specifically for administrative duties, ensuring system administrators have all the tools they need at their fingertips."
                    ]
                },
                {
                    "text": "Industry-Leading Warranty and Return Services",
                    "points": [
                        "We are among the first in the industry to offer an extensive and dynamic warranty and return service, setting new standards for customer care and product support within our system. This commitment ensures peace of mind and reliability for all users."
                    ]
                }
            ],
            "features": [
                {
                    "title": "Warranty and Return Requests",
                    "description": "Efficiently manage all warranty and return requests for both sold and defective products in your inventory. This feature provides comprehensive control over the submission process and allows detailed management of each request",
                    "addOn": false,
                    image: WarrantyAndReturnRequestsFeatureImage,
                    "points": [
                        "Utilize dynamic templates for submitting evidence and documentation for each request.",
                        "Edit all request information, including Return Goods Authorization (RGA), credits, vendors, and dynamic properties as needed.",
                        "Assign requests to specific operators and manage their statuses, which are dynamically updated.",
                        "Print request details directly without any extra addons."
                    ]
                },
                {
                    "title": "Live Chat with Customers and Vendors",
                    "description": "Maintain seamless communication with both customers and vendors through our integrated live chat feature. This tool facilitates constant interaction to ensure timely resolution of any requests.",
                    "addOn": false,
                    image: WarrantyAndReturnLiveChatFeatureImage,
                    "points": [
                        "A dedicated chatting page for vendor communications.",
                        "Enable customers to interact with operators easily via both the website and mobile application.",
                        "Integrate with iOS, Android, and browser notification systems to ensure prompt delivery of messages if the Notifications package is included.",
                        "Support the sending of images, files, and links during chats, with all communications saved in the system for future reference."
                    ]
                },
                {
                    "title": "Drivers Checklists and Extra Information Links",
                    "description": "Streamline the management of drivers and the documentation process associated with each request through dedicated system tools.",
                    "addOn": false,
                    image: WarrantyAndReturnDriversChecklistsFeatureImage,
                    "points": [
                        "Manage your drivers efficiently with a dedicated page in the system.",
                        "Generate and share links that allow customers to provide additional information required for their requests.",
                        "Track and record drivers' checklists for each request, ensuring all necessary details are completed and accessible."
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Sales",
            "slug": "sales",
            "description": "Our Sales solution integrates seamlessly with mobile and web platforms, offering a comprehensive suite of tools for managing quotes, sales orders, and invoices, alongside advanced features for price management and online payments, all designed to enhance sales processes and financial management efficiently.",
            "color": "rgba(252, 174, 73, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": SalesPackageImage,
            "content": "Our Sales solution integrates seamlessly with mobile and web platforms, offering a comprehensive suite of tools for managing quotes, sales orders, and invoices, alongside advanced features for price management and online payments, all designed to enhance sales processes and financial management efficiently.",
            "keyBenefits": [
                {
                    "text": "Dual Platform Accessibility",
                    "points": [
                        "Mobile Application: Available on both Android and iOS, this app is crafted for operators and administrators to manage system operations seamlessly from anywhere.",
                        "Web-Based Software: Specifically designed for system administrators, this platform facilitates comprehensive administrative duties effortlessly."
                    ]
                },
                {
                    "text": "Advanced Online Payment System",
                    "points": [
                        "We are pioneers in the industry with our robust and error-free online payment system, ensuring secure and smooth transactions for all users."
                    ]
                },
                {
                    "text": "Seamless Integration with Spire Systems",
                    "points": [
                        "Our package automatically syncs with Spire systems, creating corresponding sales entries effortlessly, enhancing data consistency and operational efficiency."
                    ]
                }
            ],
            "features": [
                {
                    "title": "Quotes and Sales Orders",
                    "description": "Empower your sales processes with our robust tools designed to efficiently manage customer orders and ensure timely shipment of products.",
                    "addOn": false,
                    image: SalesQuotesAndSalesOrdersFeatureImage,
                    "points": [
                        "View and manage the complete details of your customers’ quotes and sales orders.",
                        "Seamlessly create quotes, manage product listings, transactions, shipping addresses, and apply discounts, gift cards, or credits.",
                        "Select specific serial numbers and quantities from your inventory for sales orders, and manage back orders as needed.",
                        "Fully integrated with the Spire invoicing system, ensuring accurate and real-time inventory adjustments."
                    ]
                },
                {
                    "title": "Invoices and Credits",
                    "description": "Our system simplifies the management of invoices and credits, enhancing financial operations:",
                    "addOn": false,
                    image: SalesInvoicesAndCreditsFeatureImage,
                    "points": [
                        "Automatically generate invoices from submitted sales orders and easily apply existing credits.",
                        "Print invoices and manage multiple invoice payments if the online payments package is available.",
                        "Integrated with the Spire invoicing system for consistent stock level adjustments."
                    ]
                },
                {
                    "title": "Price Levels and Product Pricing",
                    "description": "Gain precise control over product pricing with our dynamic pricing system",
                    "addOn": false,
                    image: SalesPriceLevelsAndProductPricingFeatureImage,
                    "points": [
                        "Manage and view pricing based on 20 distinct price levels, offering flexible control over your pricing strategy.",
                        "Enable real-time pricing visibility in product lookup, and compare your pricing with other partners"
                    ]
                },
                {
                    "title": "Accounting and Account Receivables",
                    "description": "Keep a precise track of your organization’s receivables and payable with our comprehensive account receivables list",
                    "addOn": false,
                    image: SalesAccountingAndAccountReceivablesFeatureImage,
                    "points": [
                        "Integrated with Spire’s accounting system to ensure financial accuracy and accountability."
                    ]
                },
                {
                    "title": "Online Payments",
                    "description": "Enhance your sales system with our online payments add-on",
                    "addOn": true,
                    image: SalesOnlinePaymentsFeatureImage,
                    "points": [
                        "Facilitate the payment of quotes, sales orders, and invoices directly through the system.",
                        "Manage multiple payments and customer payment methods using advanced vault technology."
                    ]
                },
                {
                    "title": "Freight and Freight Fees",
                    "description": "Optimize your shipping processes with the freight add-on",
                    "addOn": true,
                    image: SalesFreightAndFreightFeesFeatureImage,
                    "points": [
                        "Manage shipping information, freight companies, and regions efficiently.",
                        "Set and approve freight fees, and customize free shipping rules using seven different parameters to align with your organization’s policies."
                    ]
                },
                {
                    "title": "Gift Cards and Coupons",
                    "description": "Stimulate sales and customer engagement with our flexible gift cards and coupons add-on",
                    "addOn": true,
                    image: SalesGiftCardsAndCouponsFeatureImage,
                    "points": [
                        "Allow customers to use gift cards and coupons for payments on quotes and sales orders.",
                        "Manage gift cards with options for refunds and refills, ideal for special promotions and events."
                    ]
                },
                {
                    "title": "Price Matrices and Bulk Price Manipulation",
                    "description": "Take control of product pricing with sophisticated tools",
                    "addOn": true,
                    image: SalesPriceMatricesAndBulkPriceManipulationFeatureImage,
                    "points": [
                        "Use price matrices to adjust prices based on customer groups, categories, or specific products.",
                        "Implement bulk price changes efficiently, with the ability to correct and rerun adjustments as needed."
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "BizPrint",
            "slug": "biz-print",
            "description": "Our BizPrint solution modernizes the way businesses handle printing, offering customizable templates for catalogs, labels, and packing lists that reflect real-time data changes. It streamlines the creation and printing process, saving time and reducing costs, all while ensuring your printed materials are always up-to-date.",
            "color": "rgba(71, 71, 76, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": BizPrintPackageImage,
            "content": "BizPrint streamlines printing processes by offering customizable templates for easy record printing, eliminating the need for developer involvement and allowing users to design and edit templates effortlessly.",
            "keyBenefits": [
                {
                    text: "Uniform Template Printing",
                    points: [
                        "Effortlessly print various types of data using a single, well-designed template," +
                        " streamlining the delivery process and ensuring consistent presentation.",
                    ],
                },
                {
                    text: "Dynamic Data Reflection",
                    points: [
                        "Our system automatically updates printed records to reflect any changes made, eliminating the" +
                        " need to adjust templates manually. This ensures that all printed materials are current without additional effort.",
                    ],
                },
                {
                    text: "Enhanced Printing Efficiency",
                    points: [
                        "Accelerate the printing of catalogs and labels while reducing dependency and costs" +
                        " associated with traditional industry services. Our streamlined process not only saves time but also significantly cuts down on expenses.",
                    ],
                }
            ],
            "features": [
                {
                    "title": "Catalog",
                    "description": "View and print the catalogs of your products easily using a customized template for your company with just a few clicks. As this package is already integrated with other parts of the system, all you need to do to create a catalog is to select the products to put into the catalog.",
                    "addOn": false,
                    image: BizPrintCatalogFeatureImage,
                    "points": [
                        "Template Flexibility: Save and utilize multiple catalog templates for a range of different uses, enhancing the" +
                        " adaptability and application of your catalogs.",
                        "Efficient Creation: Produce numerous catalogs swiftly, tasks that traditionally could take days to months now can be accomplished" +
                        " quickly. Any updates in product details, tags, or categories are immediately reflected in new editions of the catalogs.",
                    ]
                },
                {
                    "title": "Labeling",
                    "description": "Easily generate labels for all your products using custom-made label templates that can fit all your existing products with a few clicks. The labeling process has never been easier and faster as all the product information already exists in the system.",
                    "addOn": false,
                    image: BizPrintLabelingFeatureImage,
                    "points": [
                        "Template Variety: Maintain a selection of label templates, allowing for flexibility across various products and" +
                        " applications.",
                        "Time Efficiency: Dramatically reduce the time required for preparing labels, enabling faster production and distribution.",

                    ]
                },
                {
                    "title": "Packing Lists",
                    "description": "Generate your desired packing lists to be shipped with your products just by having the list of" +
                        " products and their serial numbers. This feature is designed for organizations that ship multiple products and lists all the necessary information such as the weight, size, and its reference numbers.",
                    "addOn": false,
                    image: BizPrintPackingListsFeatureImage,
                    "points": [
                        "Template Options: Utilize multiple packing list templates, tailored for a variety of products and shipping needs.",
                        "Reduced Preparation Time: Significantly decrease the time required to prepare packing lists, ensuring quick and accurate shipments" +
                        " of your products.",
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Clients Platform",
            "slug": "clients-platform",
            "description": "Our Clients Platform revolutionizes how businesses engage with their clientele, offering a comprehensive mobile and web-based solution. It allows customers to explore products, compare them, obtain quotes, and make purchases effortlessly, facilitating a strong entry into e-commerce and enhancing customer relationships.",
            "color": "rgba(159, 124, 244, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": ClientsPlatformPackageImage,
            "content": "Our Clients Platform revolutionizes how businesses engage with their clientele, offering a comprehensive mobile and web-based solution. It allows customers to explore products, compare them, obtain quotes, and make purchases effortlessly, facilitating a strong entry into e-commerce and enhancing customer relationships.",
            "keyBenefits": [
                {
                    "text": "Dual Platform Accessibility",
                    "points": [
                        "Mobile Application: Available on both Android and iOS, this app is designed for your organization’s clients," +
                        " enabling them to interact with your services on-the-go.",
                        "Web-Based Software: Specifically crafted for administrators, this platform facilitates comprehensive management" +
                        " duties efficiently.",
                    ]
                },
                {
                    "text": "Enhanced Customer Interaction:",
                    "points": [
                        "Provides a seamless interface for customers to browse products, compare features, obtain quotes, and make purchases easily, enhancing the user experience and customer satisfaction"
                    ]
                },
                {
                    "text": "E-Commerce Advancement",
                    "points": [
                        "Offers a professional foundation for your organization to actively engage in the e-commerce space, expanding your target market and audience reach"
                    ]
                },
                {
                    "text": "Building Trust and Engagement",
                    "points": [
                        "Fosters stronger relationships with customers by providing a reliable and user-friendly platform, positioning your organization as a trusted choice in the marketplace."
                    ]
                }
            ],
            "features": [
                {
                    "title": "Dynamic Homepages",
                    "addOn": false,
                    "description": "Create dynamic, engaging homepages for your customers' platforms, whether on mobile apps or websites, with ease. Tailor homepages to display categories, featured products, promotional sales, and more, including banners and slideshows.",
                    image: ClientsPlatformDynamicHomepagesFeatureImage,
                    "points": [
                        "Versatile Layouts: Easily switch between multiple homepage versions with just a click, allowing for timely" +
                        " updates and tests.",
                        "Customizable Components: Mix and match from seven different component types to craft visually appealing and functional homepages.",
                    ]
                },
                {
                    "title": "Lookup and Product Information",
                    "addOn": false,
                    "description": "Enhance the user experience with powerful search and product information tools right on your" +
                        " customer's website and mobile app.",
                    image: ClientsPlatformLookupAndProductInformationFeatureImage,
                    "points": [
                        "Advanced Search Capabilities: Includes basic, application, and technical search engines, providing thorough and" +
                        " tailored browsing options.",
                        "Comparison and Feedback: Offer the same robust comparison tool available on your system, allowing customers to compare products," +
                        " save favorites, and leave feedback based on their experience.",
                    ]
                },
                {
                    "title": "Pricing and Sales",
                    "addOn": true,
                    "description": "This add-on transforms the shopping experience, enabling customers to manage their purchases from quotes to payment seamlessly.",
                    image: ClientsPlatformPricingAndSalesFeatureImage,
                    "points": [
                        "Complete Sales Management: Customers can add items to their carts, view quotes, and manage invoices, with the" +
                        " ability to pay online and use credits and gift cards.",
                        "Dynamic Pricing: View real-time prices, which adjust based on specific customer profiles and applied pricing strategies.",
                    ]
                },
                {
                    "title": "Content Management System",
                    "addOn": true,
                    "description": "Our CMS empowers you to keep your customers informed and engaged with minimal reliance on technical staff.",
                    image: ClientsPlatformContentManagementSystemFeatureImage,
                    "points": [
                        "Direct Content Control: Publish and update posts and videos about new products, news, or policies directly," +
                        " keeping content fresh and relevant.",
                        "User-Friendly Interface: Change and update your website’s content through a design that's easy to use and implement instantly," +
                        " enhancing your ability to communicate with customers effectively.",

                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Task & Note Management",
            "slug": "task-note-management",
            "description": "Our Task & Note Management system streamlines daily operations by integrating context-aware tasks and notes directly within your operational software. It enhances team collaboration through shared tasks and notes, increasing productivity and operational efficiency without the clutter of traditional sticky notes or disparate software tools.",
            "color": "rgba(255, 196, 68, 0.5)",
            "planned": false,
            "specialOffer": false,
            "image": TaskAndNoteManagementPackageImage,
            "content": "Our Task & Note Management system streamlines daily operations by integrating context-aware tasks and notes directly within your operational software. It enhances team collaboration through shared tasks and notes, increasing productivity and operational efficiency without the clutter of traditional sticky notes or disparate software tools.",
            "keyBenefits": [
                {
                    text: "Context-Aware Tasks and Notes",
                    points: ["Utilize tasks and notes that are displayed contextually within the system where they" +
                    " were created, enhancing relevance and efficiency.",]
                },
                {
                    text: "Collaborative Task Management",
                    points: ["Empower your operators to collaborate seamlessly by assigning and completing tasks together," +
                    " promoting teamwork and operational cohesion.",]
                },
                {
                    text: "Digital Task System",
                    points: ["Replace traditional sticky notes and manual methods with our systematic digital approach, streamlining daily" +
                    " and operational task management for improved productivity and accuracy.",]
                }
            ],
            "features": [
                {
                    "title": "Task Management",
                    "addOn": false,
                    "description": "Integrate task management into your daily operations to significantly enhance the efficiency and productivity of your operators. By centralizing tasks within one system, operators can focus more effectively on core business activities without the distraction of switching between different software tools.",
                    image: TaskAndNoteManagementTaskManagementFeatureImage,
                    "points": [
                        "Context-Aware Tasks: Easily access tasks related to specific records, orders, or customers, streamlining" +
                        " management and execution.",
                        "Collaborative Features: Enable operators to track their daily tasks and collaborate by assigning tasks to others, fostering a" +
                        " team-oriented environment.",
                        "Boosts Operational Efficiency: By centralizing task management, your system increases overall productivity, helping your business" +
                        " achieve its goals more efficiently.",
                    ]
                },
                {
                    "title": "Note Management",
                    "addOn": false,
                    "description": "Our note management system offers a flexible and powerful tool to annotate any part of the system. These notes can be accessed later, providing a reliable reference for operators.",
                    image: TaskAndNoteManagementNoteManagementFeatureImage,
                    "points": [
                        "Context-Aware Notes: Quickly locate notes associated with specific records, orders, or customers, making" +
                        " information retrieval straightforward and fast.",
                        "Enhances Collaboration and Efficiency: Operators can share insights and information on customers, orders, and business processes," +
                        " enhancing communication and operational productivity.",
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "BizCRM",
            "slug": "customer-relations-management",
            "description": "Our Customer Relations Management platform centralizes customer data and interactions in a mobile-friendly, standalone platform, integrating seamlessly with Spire and our systems to manage accounts, leads, visits, and offers efficiently.",
            "color": "rgba(75, 78, 248, 0.5)",
            "image": CustomerRelationsManagementPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "Our CRM package is designed as a standalone platform, specifically targeting the unique needs of your company's customers and operations. This comprehensive system serves as a centralized hub for all customer-related information. It efficiently manages and tracks customer profiles, available leads, visit records, current offers, and more. Additionally, it integrates notes, tasks, and activity logs to ensure every piece of customer data is easily accessible. This holistic approach enhances customer interaction and operational efficiency, positioning your business to better manage and grow customer relationships.",
            "keyBenefits": [
                {
                    text: "Seamless Integration",
                    points: ["Our CRM is fully integrated with both the Spire system and our proprietary platforms, ensuring" +
                    " that any changes are instantly synchronized across all connected platforms for consistent data management.",]
                },
                {
                    text: "Dedicated Standalone Platform",
                    points: ["Specifically engineered to manage customer relations, this platform provides specialized tools and" +
                    " features tailored to enhance customer interactions.",]
                },
                {
                    text: "Modern, Mobile-Friendly Design",
                    points: ["Built using the latest technology, our CRM offers a user-friendly interface that is optimized for" +
                    " mobile devices, ensuring a seamless experience whether you are at your desk or on the move.",]
                },
                {
                    text: "Easy Access to Core Functions",
                    points: ["Strategically placed at the top of the platform, the actions for creating and managing entities are" +
                    " readily accessible, allowing for quick and efficient operations.",]
                },
                {
                    text: "Customizable Entity Properties",
                    points: ["Dynamically configure properties for each entity, such as accounts and members, with ease. This" +
                    " flexibility allows you to tailor the system to meet specific needs and preferences, enhancing usability and effectiveness.",]
                }
            ],
            "features": [
                {
                    "title": "Leads Management",
                    "addOn": false,
                    "description": "Efficiently create, view, and manage profiles for potential customers. Organize leads into dynamically created status stages and prioritize them according to their importance. Promote leads to customer status as relationships progress.",
                    image: CustomerRelationsManagementLeadsManagementFeatureImage,
                    "points": [
                        "Dynamic Properties: Define customizable properties for leads to suit various market or industry needs.",
                        "Progress Tracking: Monitor each lead's development with detailed notes and identified pain points, accessible at any time.",
                    ]
                },
                {
                    "title": "Account and Member Management",
                    "addOn": false,
                    "description": "Manage comprehensive profiles for your customers and their members, including images, general information, social media accounts, and custom property values.",
                    image: CustomerRelationsManagementAccountAndMemberManagementFeatureImage,
                    "points": [
                        "Ease of Access: Quickly view and edit accounts or member details with just a few clicks, streamlining the" +
                        " management process.",
                        "Customizable Properties: Set dynamic properties for accounts to adapt to different industry requirements.",
                    ]
                },
                {
                    "title": "Visits, Follow-ups, and Offers",
                    "addOn": false,
                    "description": "Document visits, manage follow-up interactions, and create tailored offers for customers with ease.",
                    image: CustomerRelationsManagementVisitsFollowUpsAndOffersFeatureImage,
                    "points": [
                        "Detailed Record-Keeping: Assign images, set property values, and attach notes or tasks to visits and follow-ups" +
                        " for thorough documentation.",
                        "Offer Management: Modify and personalize offers, maintaining flexibility to adapt to customer needs and preferences.",
                    ]
                },
                {
                    "title": "Tasks and Notes",
                    "addOn": false,
                    "description": "Effortlessly track and manage tasks and notes across the platform. Maintain visibility of task progress and associate notes with specific accounts, visits, or general operations.",
                    image: CustomerRelationsManagementTasksAndNotesFeatureImage,
                    "points": [
                        "Configurable Management: Define and adjust tasks and notes with high configurability, linking them to relevant entities like accounts or visits for integrated oversight."
                    ]
                },
                {
                    "title": "Logs and History",
                    "addOn": false,
                    "description": "Access a detailed log of all changes made within the system, available centrally or alongside specific entity properties. This feature allows for historical comparison and easy reversal if necessary.",
                    image: CustomerRelationsManagementLogsAndHistoryFeatureImage,
                    "points": [
                        "Historical Tracking: Monitor and revert changes to any property, ensuring accuracy and consistency.",
                        "Reporting Utility: Utilize historical data for comprehensive reporting purposes, enhancing external communication and analysis.",
                    ]
                },
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Non-Conformance Reports",
            "slug": "non-conformance-reports",
            "description": "Our Non-Conformance Reports (NCR) package offers a highly configurable platform for identifying and analyzing business non-conformities, aiming to enhance operational efficiency and effectiveness through structured problem-solving and audit processes.",
            "color": "rgba(212, 232, 255, 1)",
            "image": NonConformanceReportsPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "Our Non-Conformance Reports (NCR) package offers a highly configurable platform for identifying and analyzing business non-conformities, aiming to enhance operational efficiency and effectiveness through structured problem-solving and audit processes.",
            "keyBenefits": [
                {
                    text: "Strategic Conformity Identification",
                    points: ["Offers a structured approach to pinpointing areas of conformity within your" +
                    " business, enabling targeted analysis and development of solutions to enhance both efficiency and effectiveness.",]
                },
                {
                    text: "Customizable Configuration",
                    points: ["Highly adaptable, allowing you to tailor processes and features specifically to meet the unique needs" +
                    " of your organization, ensuring that the system aligns perfectly with your operational goals and strategies.",]
                }
            ],
            "features": [
                {
                    "title": "NCR Submission and Information",
                    "addOn": false,
                    "description": "Optimize your business operations by identifying, analyzing, and auditing conformities. This proactive approach ensures issues are resolved promptly, aligning with your organization's safety and quality standards.",
                    image: NonConformanceReportsNCRSubmissionAndInformationFeatureImage,
                    "points": [
                        "Comprehensive Reporting: Access and review a detailed list of existing reports, with the ability to delve into" +
                        " specific details at any time.",
                        "Efficient Report Submission: Utilize a tailored process for submitting new reports, customized to fit your organization's specific" +
                        " needs.",
                        "Detailed Management: View and manage the details of each report, including reviewing notes and actions to thoroughly audit each" +
                        " conformity.",
                    ]
                },
                {
                    "title": "Tasks and Notes",
                    "addOn": false,
                    "description": "Efficiently manage tasks and notes within this package, enhancing oversight and coordination of NCR-related activities.",
                    image: NonConformanceReportsTasksAndNotesFeatureImage,
                    "points": [
                        "Task Tracking: Monitor the status of tasks, with capabilities to view and manage them directly from specific" +
                        " report pages.",
                        "Integrated Notes: Utilize dedicated pages for tasks and notes, which are also accessible from each NCR page, ensuring relevant" +
                        " information is always at hand.",
                    ]
                },
                {
                    "title": "Configurable Process Settings",
                    "addOn": false,
                    "description": "Tailor the handling of non-conformance reports (NCRs) with extensive customizable settings, ensuring the system meets your organization's unique requirements.",
                    image: NonConformanceReportsConfigurableProcessSettingsFeatureImage,
                    "points": [
                        "Customizable Processes: Adjust statuses, process flows, and action groups to suit specific operational needs.",
                        "Dynamic Configurations: Maintain a dynamic list of statuses and action groups for each report, providing flexibility and precise" +
                        " control.",
                        "Custom Codes: Set customized starting codes for new reports, facilitating organized tracking and categorization.",
                    ]
                },
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "BizHR",
            "slug": "biz-hr",
            "description": "Our HR module offers useful utilities for personnel management and efficient time sheet management in a streamlined native app that runs on personnel's phones and a" +
                " dedicated administrative platform for reporting and employee management. Through our HR module we ensure accurate and streamlined time tracking for enhanced productivity.",
            "color": "rgba(222,169,234,0.6)",
            "image": TimeTrackerPackageImage,
            "planned": false,
            "specialOffer": false,
            "content": "Our HR module offers useful utilities for personnel management and efficient time sheet management in a streamlined native app that runs on personnel's phones and a" +
                " dedicated administrative platform for reporting and employee management. Through our HR module we ensure accurate and streamlined time tracking for enhanced productivity.",
            "keyBenefits": [
                {
                    text: "Seamless Platform Integration",
                    points: [
                        "Fully integrated within the platform itself, ensuring a smooth and cohesive user" +
                    " experience without the need for external applications or services.",]
                },
                {
                    text: "User-centric Native App and Administrative Platform",
                    points: [
                        `Our system is designed to work seamlessly within the users' phones which enables many of the sought after capabilities within the time-managemnet realm, such as location tracking, clocking in and our limitations by location and or qrcode scanning.`
                    ]
                }
            ],
            "features": [
                {
                    "title": "Time Tracking",
                    "addOn": false,
                    "description": "Enhance the management of employee hours with our advanced time keeping feature, which allows staff to clock in and out remotely or on-site. Supported by a" +
                        " precise geolocation tracking system, monitoring work hours is both straightforward and reliable.",
                    image: TimeTrackerTimeKeepingFeatureImage,
                    "points": [
                        "Real-Time Updates: Easily see who is currently working, who is off, or on a break with instant updates.",
                        "Automatic Reminders: Set up auto-alerts to remind staff to log their hours, ensuring accurate time tracking.",
                        "Remote Work Compatibility: Facilitate remote working arrangements with secure and accurate geolocation tracking, providing" +
                        " flexibility without compromising on oversight.",
                    ]
                },
                {
                    "title": "Reports",
                    "addOn": false,
                    "description": "Our reporting tools provide valuable insights into employee productivity by analyzing the time spent on various tasks. These reports are crucial for maintaining efficient operations and accurate payroll management.",
                    image: TimeTrackerReportsFeatureImage,
                    "points": [
                        "Timesheet Analysis: Generate detailed reports from timesheets to assess the effectiveness of your workforce and" +
                        " optimize labor allocation.",
                        "Payroll Accuracy: Use timesheet data to maintain precise payroll records, ensuring employees are paid correctly for their time" +
                        " worked.",
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "Notifications",
            "slug": "notifications",
            "description": "Our Notifications package is designed to instantly share time-sensitive information with business partners and customers through iOS, Android, and browser notification systems, enhancing day-to-day operations and engagement flexibility.",
            "color": "rgba(175, 205, 251, 0.5)",
            "image": NotificationsPackageImage,
            "planned": true,
            "specialOffer": false,
            "content": "Our Notifications package is designed to instantly share time-sensitive information with business partners and customers through iOS, Android, and browser notification systems, enhancing day-to-day operations and engagement flexibility.",
            "keyBenefits": [
                {
                    text: "Timely Information Sharing",
                    points: ["Ensures time-sensitive information is communicated promptly to business partners," +
                    " facilitating swift and informed decision-making.",]
                },
                {
                    text: "Flexibility and Control",
                    points: ["Provides your business with the ability to influence and monitor activities on customer websites, offering" +
                    " a greater degree of flexibility and oversight.",]
                },
                {
                    text: "Operational Enhancement",
                    points: ["Streamlines and improves day-to-day business processes and operations, contributing to overall efficiency" +
                    " and effectiveness.",]
                },
                {
                    text: "Comprehensive Integration",
                    points: ["Fully integrated with iOS, Android, and browser notification systems, ensuring that important alerts and" +
                    " updates reach your team and customers regardless of their preferred platform.",]
                }
            ],
            "features": [
                {
                    "title": "Operator Notifications",
                    "addOn": false,
                    "description": "Enhance communication within your organization by enabling personnel to receive notifications through various mediums—such as phone and browser notifications—triggered by specific events within the system.",
                    image: NotificationsOperatorNotificationsFeatureImage,
                    "points": [
                        "Customizable Categories: Create and manage categories for employees to organize notifications effectively." +
                        " Easily view notifications or navigate directly to the related event.",
                        "Diverse Alerts: Receive timely alerts for various activities, including chat interactions with customers or vendors, customer" +
                        " activity on their platforms, and updates on new sales or purchase orders relevant to inventory personnel.",
                    ]
                },
                {
                    "title": "Customer Notifications",
                    "addOn": false,
                    "description": "Proactively engage with your customers by sending tailored notifications through their client platforms, enhancing their experience and keeping them informed of new updates and offers.",
                    image: NotificationsCustomerNotificationsFeatureImage,
                    "points": [
                        "Versatile Notification System: Directly send notifications to customers’ platforms with the flexibility to" +
                        " customize the title, message, and purpose of each notification.",
                        "Engagement Opportunities: Use notifications to announce new products or categories, promote special offers or discounts, and" +
                        " highlight specific search criteria or features within the application.",
                    ]
                }
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        },
        {
            "title": "BizFile",
            "slug": "biz-file",
            "description": "BizFile is designed to be a centralized hub for all your organizational documents and files. This platform enables seamless access to files across your other platforms, simplifying the process of viewing, managing, and sharing documents within your organization. With BizFile, managing your organization's files becomes straightforward, promoting efficiency and collaboration among team members.",
            "color": "rgba(186, 104, 200, 0.5)",
            "image": BizFilePackageImage,
            "planned": true,
            "specialOffer": false,
            "content": "BizFile is designed to be a centralized hub for all your organizational documents and files. This platform enables seamless access to files across your other platforms, simplifying the process of viewing, managing, and sharing documents within your organization. With BizFile, managing your organization's files becomes straightforward, promoting efficiency and collaboration among team members.",
            "keyBenefits": [
                {
                    text: "Comprehensive Integration",
                    points: [
                        "BizFile is fully integrated with all other platforms and applications within your system," +
                        " ensuring seamless interaction and data consistency across your organizational tools.",
                    ]
                },
                {
                    text: "Optimized for Usability",
                    points: [
                        "Specifically designed with accessibility in mind, BizFile enhances the file management experience by" +
                        " providing an intuitive interface that simplifies the way your organization accesses, manages, and shares" +
                        " files."
                    ],
                }
            ],
            "features": [
                {
                    "title": "File and Folder Management",
                    "addOn": false,
                    "description": "Efficiently manage your organizational files and folders with our comprehensive management tools. This feature allows you to sort, categorize, and search through your files using an intuitive, user-centric interface.",
                    image: BizFileFileAndFolderManagementFeatureImage,
                    "points": [
                        "Flexible Organization: Easily organize your files into various folder structures, adjust access levels, and" +
                        " move items as needed to suit your organizational requirements.",
                        "Advanced Search Mechanism: Quickly find files using a filtering system that tailors search results based on your specific needs.",
                        "Recovery Options: Remove unwanted files with the option to retrieve them later from the trash if necessary.",
                        "Detailed File Information: View essential details about your files and folders at a glance, simplifying file management.",

                    ]
                },
                {
                    "title": "Sharing with Others",
                    "addOn": false,
                    "description": "Collaborate and share files within your organization effortlessly. This feature enables administrators to control access precisely, ensuring appropriate visibility and collaboration on files and folders.",
                    image: BizFileSharingWithOthersFeatureImage,
                    "points": [
                        "Easy File Sharing: Share files and folders with colleagues within your organization through a few simple clicks.",
                        "Dynamic Access Control: Administrators can manage who has access to specific files and can revoke access at any time to maintain" +
                        " security and compliance.",
                    ]
                },
                {
                    "title": "Accessible Anywhere",
                    "addOn": false,
                    "description": "With integration across our systems, BizFile ensures that your files are always accessible within the relevant context of your work, whether it be related to a specific member, customer, order, or record.",
                    image: BizFileAccessibleAnywhereFeatureImage,
                    "points": [
                        "Contextual Accessibility: Upload and access files directly within the platforms where they are most needed," +
                        " without switching back to the BizFile system.",
                        "Seamless Integration: Files are readily available and easily retrievable across different sections of the system, enhancing" +
                        " workflow continuity and efficiency.",
                    ]
                },
            ],
            "tutorialsPlaylistLink": null,
            "tutorialLinks": [],
            "documentationLink": null,
        }
    ]
}

export default StaticContent;
